import React, { useState, useEffect, useContext } from "react";

import axios from "axios";

import GridContainer from "components/Grid/GridContainer";
import GridItem from "components/Grid/GridItem";
import Button from "components/CustomButtons/Button.js";
import FloatInput from "components/Input/FloatInput.js";
import UserService from "services/UserService";
import { thresholdtext } from "variables/patrimoine.js";
import { getSite } from "services/ConfigServices";
import AdvancedSearchContext from "context/AdvancedSearchContext";
import { NotificationManager } from 'react-notifications';
import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme) => ({
    root: {
      flexGrow: 1,
      backgroundColor: '#fff',
      display: "flex",
      fontFamily: '"Source Sans Pro",sans-serif',
  
    },
    tabs: {
      borderRight: `1px solid rgba(0, 0, 0, 0.12)`,
    },
    textInput: {
      fontSize: "14px",
      fontFamily: '"Source Sans Pro",sans-serif',
      "& .MuiInputBase-input": {
        fontSize: "14px",
        fontFamily: '"Source Sans Pro",sans-serif',
      },
    },
    tab: {
      paddingLeft: "0rem",
      marginLeft: "0rem",
      flexDirection: "column",
      textAlign: "left",
      display: "grid",
      justifyContent: "left",
      alignItems: "flex-start",
      maxWidth: "3rem",
    },
    input: {
      display: "flex",
      flexDirection: "column",
      margin: "1rem 0rem 0rem",
      color: "#000000",
      "& .MuiInputBase-input": {
        fontSize: "14px",
        fontFamily: '"Source Sans Pro",sans-serif',
      },
    },
    inputImage: {
      display: "flex",
      flexDirection: "column",
      margin: "0rem 0rem 0rem",
      color: "#000000",
      "& .MuiInputBase-input": {
        fontSize: "14px",
        fontFamily: '"Source Sans Pro",sans-serif',
      },
    },
    inputTitle: {
      margin: "0.2rem 0rem 0.05rem 0.5rem",
      color: "rgba(0, 0, 0, 0.54)",
      fontFamily: '"Source Sans Pro",sans-serif',
      fontSize: "12px",
    },
    select: {
      display: "flex",
      flexDirection: "column",
      margin: "1rem 0.5rem",
    },
    switch: {
      marginLeft: "0.5rem",
    },
  }));

function Threshold(props) {
    const permis = JSON.parse(localStorage.getItem('permission')) || [];
    const realestateupdate = permis.includes("realestate_update");

    const [reducedtemperature , setReducedtemperature] = useState("");
    const [comforttemperature , setComforttemperature] = useState("");
    const [lowhumiditylevel  , setLowhumiditylevel] = useState("");
    const [highhumiditylevel , setHighhumiditylevel] = useState("");
    const [moderateairqualityco2threshold  , setModerateairqualityco2threshold] = useState("");
    const [lowairqualityco2threshold  , setLowairqualityco2threshold] = useState("");


    const appContext = useContext(AdvancedSearchContext);
    const { chartIdGroup } = appContext;
  
    const handleReducedtemperatureChange = (event) => { setReducedtemperature(event.target.value); };
    const handleComforttemperatureChange = (event) => { setComforttemperature(event.target.value); };
    const handleLowhumiditylevelChange = (event) => { setLowhumiditylevel(event.target.value); };
    const handleHighhumiditylevelChange = (event) => { setHighhumiditylevel(event.target.value); };
    const handleModerateairqualityco2thresholdChange = (event) => { setModerateairqualityco2threshold(event.target.value); };
    const handleLowairqualityco2thresholdChange = (event) => { setLowairqualityco2threshold(event.target.value); };
  
    useEffect(() => {
      axios
        .get(
          getSite(chartIdGroup, "parameters.threshold"),
          {
            headers: {
              Authorization: `Bearer ${UserService.getToken()}`,
            },
          }
        )
        .then((res) => {
            setReducedtemperature(res.data.detail.parameters?.threshold?.reducedtemperature);
            setComforttemperature(res.data.detail.parameters?.threshold?.comforttemperature);
            setLowhumiditylevel(res.data.detail.parameters?.threshold?.lowhumiditylevel);
            setHighhumiditylevel(res.data.detail.parameters?.threshold?.highhumiditylevel);
            setModerateairqualityco2threshold(res.data.detail.parameters?.threshold?.moderateairqualityco2threshold);
            setLowairqualityco2threshold(res.data.detail.parameters?.threshold?.lowairqualityco2threshold);
        })
        .catch(() => { });
    }, []);
  
    const handleEdit = () => {
      axios
        .put(
          getSite(chartIdGroup, "parameters.threshold"),
          {
            reducedtemperature,
            comforttemperature,
            lowhumiditylevel,
            highhumiditylevel,
            moderateairqualityco2threshold,
            lowairqualityco2threshold,
          },
          {
            headers: {
              Authorization: `Bearer ${UserService.getToken()}`,
              'Content-Type': "application/json; charset=utf-8",
            },
          }
        )
        .then((res) => {
          if (res.status == 200) {
            NotificationManager.success("Modifications enregistrées");
          }
          else {
            NotificationManager.error("Une erreur est survenue");
          }
        })
        .catch(() => {
          NotificationManager.error("Une erreur est survenue");
        });
    };
  
    const classes = useStyles();
    return (
      <div style={{ marginTop: "-15px" }}>
        <GridContainer>
          <GridItem xs={12} sm={12} md={12}>
          <div>
            <FloatInput
              inputTitle={thresholdtext.reducedtemperature}
              floatInput={reducedtemperature}
              handleFloatInputChange={handleReducedtemperatureChange}
              disabled={!realestateupdate}
            />
          </div>
          <div>
            <FloatInput
              inputTitle={thresholdtext.comforttemperature}
              floatInput={comforttemperature}
              handleFloatInputChange={handleComforttemperatureChange}
              disabled={!realestateupdate}
            />
          </div>
          <div>
            <FloatInput
              inputTitle={thresholdtext.lowhumiditylevel}
              floatInput={lowhumiditylevel}
              handleFloatInputChange={handleLowhumiditylevelChange}
              disabled={!realestateupdate}
            />
          </div>
          <div>
            <FloatInput
              inputTitle={thresholdtext.highhumiditylevel}
              floatInput={highhumiditylevel}
              handleFloatInputChange={handleHighhumiditylevelChange}
              disabled={!realestateupdate}
            />
          </div>
          <div>
            <FloatInput
              inputTitle={thresholdtext.moderateairqualityco2threshold}
              floatInput={moderateairqualityco2threshold}
              handleFloatInputChange={handleModerateairqualityco2thresholdChange}
              disabled={!realestateupdate}
            />
          </div>
          <div>
            <FloatInput
              inputTitle={thresholdtext.lowairqualityco2threshold}
              floatInput={lowairqualityco2threshold}
              handleFloatInputChange={handleLowairqualityco2thresholdChange}
              disabled={!realestateupdate}
            />
          </div>
          </GridItem>
          <GridItem xs={12} sm={12} md={12}>
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "flex-end",
                marginTop: "1rem",
                marginLeft: "auto",
                marginRight: "0.2rem",
              }}
            >
              {realestateupdate ? <Button
                style={{
                  color: "#FFFFFF",
                  backgroundColor: "#91C73C",
                  fontWeight: "normal",
                  fontWeight: "bold",
                  height: "40px",
                  fontSize: "0.75rem",
                  padding: "5px 15px",
                  marginRight: "5px",
                  marginBottom: "0px",
                  marginTop: "0px",
                  fontFamily: '"Source Sans Pro",sans-serif',
                }}
                onClick={() => {
                  handleEdit();
                }}
              >
                Enregistrer
              </Button> : <></>}
            </div>
          </GridItem>
        </GridContainer>
  
      </div>
    );
  }

  export {Threshold}